import React, { useState } from 'react';
import PopupBase from '../base/PopupBase';
import CustomButton from '../../components/buttons/CustomButton';
import Toast from '../../components/support/Toast';
import IconSave from '@mui/icons-material/SaveAltOutlined';
import { InputAdornment, TextField } from '@mui/material';
import { DataProviderInstance } from '../../api/DataProvider';
import styles from './MotorMilestonePopup.module.css';

const WEEKS_MIN = 22;
const WEEKS_MAX = 44;

const digits = (value, max) => value.replace(/\D/g, '').slice(0, max);

/**
 * Idade gestacional ao nascer (semanas e dias). Abaixo de 37 semanas os
 * marcos motores usam a idade corrigida até os 2 anos. Semanas em branco
 * apagam a informação.
 */
function BirthInfoPopup({ patientId, birthInfo, OnHide }) {
  const { SetPatientBirthInfo } = DataProviderInstance();

  const [weeks, setWeeks] = useState(birthInfo?.gestationalWeeks != null ? String(birthInfo.gestationalWeeks) : '');
  const [days, setDays] = useState(birthInfo?.gestationalDays != null ? String(birthInfo.gestationalDays) : '');
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState({ open: false, message: '', severity: 'error' });

  const showToast = (message, severity = 'error') => setToast({ open: true, message, severity });

  function saveHandler() {
    if (saving) return;
    if (weeks !== '' && (Number(weeks) < WEEKS_MIN || Number(weeks) > WEEKS_MAX)) {
      showToast(`Informe as semanas entre ${WEEKS_MIN} e ${WEEKS_MAX}.`);
      return;
    }
    if (days !== '' && Number(days) > 6) {
      showToast('Os dias vão de 0 a 6.');
      return;
    }

    setSaving(true);
    const payload = { gestationalWeeks: weeks, gestationalDays: weeks === '' ? '' : days };
    SetPatientBirthInfo(patientId, payload, (response) => {
      setSaving(false);
      if (response && response.status === 'SUCCESS') {
        OnHide(true);
      } else {
        showToast(response?.error || 'Não foi possível salvar a idade gestacional.');
      }
    });
  }

  const content = (
    <div className={styles.container}>
      <div className={styles.row}>
        <TextField
          size="small"
          label="Semanas"
          className={styles.small}
          value={weeks}
          onChange={(e) => setWeeks(digits(e.target.value, 2))}
          inputProps={{ inputMode: 'numeric' }}
          InputProps={{ endAdornment: <InputAdornment position="end">sem</InputAdornment> }}
        />
        <TextField
          size="small"
          label="Dias"
          className={styles.small}
          value={days}
          onChange={(e) => setDays(digits(e.target.value, 1))}
          inputProps={{ inputMode: 'numeric' }}
          InputProps={{ endAdornment: <InputAdornment position="end">d</InputAdornment> }}
        />
      </div>
      <span className={styles.hint}>
        Com menos de 37 semanas, os marcos usam a idade corrigida até os 2 anos. Deixe em branco para apagar.
      </span>

      <Toast
        open={toast.open}
        message={toast.message}
        severity={toast.severity}
        onClose={() => setToast({ ...toast, open: false })}
      />
    </div>
  );

  const footer = (
    <div className={styles.footer}>
      <CustomButton
        variant="outlined"
        style="secondary"
        label="Cancelar"
        onClick={() => OnHide(false)}
        enabled={!saving}
      />
      <CustomButton
        style="primary"
        variant="contained"
        label="Salvar"
        icon={<IconSave />}
        onClick={saveHandler}
        loading={saving}
        enabled={!saving}
      />
    </div>
  );

  return (
    <PopupBase
      Title="Idade gestacional ao nascer"
      Content={content}
      Footer={footer}
      OnClose={() => OnHide(false)}
      maxWidth="xs"
    />
  );
}

export default BirthInfoPopup;
